import c_2_1 from "../../assets/sound-conversation/c_2_1.mp3"
import c_2_2 from "../../assets/sound-conversation/c_2_2.mp3"
import c_2_3 from "../../assets/sound-conversation/c_2_3.mp3"

export const audio2 = [
   {
    'text':'-Chào anh! Tên anh là gì?\n-Chào em! tên tôi là Sơn, thế còn em?\n-Tên em là Misaki.\n-Em đến từ đâu? Em đến từ Nhật Bản.\n-Kia là ai?\n-Kia là anh Tony, anh ấy đến từ Mỹ.\n-Rất vui được gặp em và Tony.\n-Rất vui được gặp anh.',
    'audio': c_2_1,
  },

];
export const audio2_1 = [

  {
    'text':'-Chào anh Frank, đây là Son, em trai tôi.\n-Chào em Lan và em Sơn. Đây là ông George, thầy giáo của tôi.\n-Chào anh Frank và thấy George. rat vui duoc gap thay va anh.\n-Cám ơn em! Thưa thầy George! Kia là Lan, cô giáo tiếng Việt của tôi.\n-Xin chào! Tôi là George đến từ Anh. Rất vui được gặp các em.',
    'audio':c_2_2,
  },

];
export const audio2_2 = [

  {
    'text':'-Chào chị, lâu rồi không gặp chị! Chị có khỏe không?\n-Chị khoe, cảm ơn Lần. Thế còn em?\n-Dạo này, em không được khỏe lắm.\n-Thế à! Em giữ sức khỏe nhé!\n-Vàng! cảm ơn chị ạ!',
    'audio':c_2_3,
  }
];